import React, { Suspense } from 'react'
import { Route, Routes } from 'react-router-dom'
import NotFoundPage from 'src/pages/NotFoundPage'
const Content = ({ routes }) => {
  return (
    <>
      <Suspense>
        <Routes>
          {routes.map((route, idx) => {
            return (
              route.element && (
                <Route
                  key={idx}
                  path={route.path}
                  exact={route.exact}
                  name={route.name}
                  element={<route.element />}
                />
              )
            )
          })}
          <Route path="*" element={<NotFoundPage />} />
        </Routes>
      </Suspense>
    </>
  )
}
export default React.memo(Content)
